import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CellTool } from "../../models/collaborate.model";

interface ToolsState {
    // Define your state properties here
    selectedTestTool: CellTool | null;
}

const initialState: ToolsState = {
    // Set initial state values here
    selectedTestTool: null
};

const toolsSlice = createSlice({
    name: "tools",
    initialState,
    reducers: {
        // Define your actions and reducers here
        setSelectedTestTool(state, action: PayloadAction<CellTool>) {
            state.selectedTestTool = action.payload;
        }
    }
});

export const { setSelectedTestTool } = toolsSlice.actions;
export default toolsSlice.reducer;
